import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";
const fetchUpdateAdminAssignment = ({ id, ...data }) => {
  return api.put(`/admin/assignment/${id}`, data);
};

export const useUpdateAdminAssignmentQuery = () => {
  return useMutation({ mutationFn: fetchUpdateAdminAssignment });
};
